/**
 * Collection Ads - Handles positioning of promotional ads within product listing grids
 * Supports responsive positioning with different positions for desktop and mobile viewports
 */

const MOBILE_BREAKPOINT = 749;

/**
 * Initializes the collection ads positioning system
 * Positions ads based on viewport size and configured positions
 */
function init() {
  const productGrid = document.querySelector('#product-grid');

  if (!productGrid) {
    return;
  }

  const products = [...productGrid.querySelectorAll('li')];
  const ads = [...document.querySelectorAll('.collection-ad')];

  if (ads.length === 0) {
    return;
  }

  positionAds(ads, products);

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      positionAds(ads, products);
    }, 150);
  });
}

/**
 * Positions all ads in the product grid based on viewport size
 * @param {HTMLElement[]} ads - Array of ad elements to position
 * @param {HTMLElement[]} products - Array of product elements in the grid
 */
function positionAds(ads, products) {
  const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

  ads.forEach((ad) => {
    const desktopPosition = Number(ad.getAttribute('data-position'));
    const mobilePositionAttr = ad.getAttribute('data-position-mobile');
    const mobilePosition = mobilePositionAttr ? Number(mobilePositionAttr) : desktopPosition;

    const position = isMobile ? mobilePosition : desktopPosition;

    moveAd(ad, position, products);
  });
}

/**
 * Moves an ad element to the specified position in the product grid
 * @param {HTMLElement} ad - The ad element to move
 * @param {number} position - Target position (1-based index). 0 = bottom of grid
 * @param {HTMLElement[]} products - Array of product elements in the grid
 */
function moveAd(ad, position, products) {
  if (position === 0 || !position) {
    ad.style.display = 'block';
    return;
  }

  if (products.length < position) {
    ad.remove();
    return;
  }

  products.forEach((product, index) => {
    const productPosition = index + 1;

    if (position === productPosition) {
      ad.style.display = 'block';
      product.parentNode.insertBefore(ad, product);
    }
  });
}

/**
 * Resets collection ads in Shopify theme editor
 * Removes ads from the DOM to prepare for re-initialization
 */
function shopifyThemeReset() {
  const productGrid = document.querySelector('#product-grid');

  if (!productGrid) {
    return;
  }

  const ads = [...productGrid.querySelectorAll('.collection-ad')];

  ads.forEach((ad) => {
    ad.remove();
  });
}

init();

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => shopifyThemeReset());
  document.addEventListener('shopify:section:reorder', () => shopifyThemeReset());
}
